<div class="info-icon-container">
  <div class="k-table-td">
    <ng-content></ng-content>
  </div>
  <div *ngIf="content && showIcon" [class]="'tool-tip ' + 'tool-tip-'+position" [ngbTooltip]="content"
    placement="top-left"></div>
  <div *ngIf="showIcon" [class]="'info-icon ' + position + ' ' + iconStyle"></div>
</div>